import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { EssaySwitchStrategy } from './essay.strategy';
import { SpeakingSwitchStrategy } from './speaking.strategy';
import { FillInBlankSwitchStrategy } from './fill-in-blank.strategy';
import { MatchingSwitchStrategy } from './matching.strategy';
import { MultipleChoiceSwitchStrategy } from './multiple-choice.strategy';
import { SingleChoiceSwitchStrategy } from './single-choice.strategy';
export var QuestionTypeSwitchStrategyManager = /*#__PURE__*/function () {
  function QuestionTypeSwitchStrategyManager() {
    _classCallCheck(this, QuestionTypeSwitchStrategyManager);

    _defineProperty(this, "strategies", void 0);

    this.strategies = new Map();
    this.registerDefaultStrategies();
  }
  /**
   * Get singleton instance
   */


  _createClass(QuestionTypeSwitchStrategyManager, [{
    key: "registerDefaultStrategies",
    value:
    /**
     * Register all default strategies
     */
    function registerDefaultStrategies() {
      this.registerStrategy(new SingleChoiceSwitchStrategy());
      this.registerStrategy(new MultipleChoiceSwitchStrategy());
      this.registerStrategy(new EssaySwitchStrategy());
      this.registerStrategy(new SpeakingSwitchStrategy());
      this.registerStrategy(new FillInBlankSwitchStrategy());
      this.registerStrategy(new MatchingSwitchStrategy());
    }
  }, {
    key: "registerStrategy",
    value: function registerStrategy(strategy) {
      this.strategies.set(strategy.fromType, strategy);
    }
  }, {
    key: "getStrategy",
    value: function getStrategy(fromType) {
      return this.strategies.get(fromType);
    }
  }, {
    key: "executeSwitch",
    value: function executeSwitch(fromType, toType) {
      var strategy = this.getStrategy(fromType);

      if (!strategy) {
        console.error("[QuestionTypeSwitch] No strategy found for question type: ".concat(fromType));
        return null;
      }

      if (!strategy.canHandle(toType)) {
        console.warn("[QuestionTypeSwitch] Strategy ".concat(fromType, " cannot handle switch to ").concat(toType));
        return null;
      }

      return strategy.execute(toType);
    }
  }, {
    key: "getRegisteredTypes",
    value: function getRegisteredTypes() {
      return Array.from(this.strategies.keys());
    }
  }, {
    key: "hasStrategy",
    value: function hasStrategy(questionType) {
      return this.strategies.has(questionType);
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!QuestionTypeSwitchStrategyManager.instance) {
        QuestionTypeSwitchStrategyManager.instance = new QuestionTypeSwitchStrategyManager();
      }

      return QuestionTypeSwitchStrategyManager.instance;
    }
  }]);

  return QuestionTypeSwitchStrategyManager;
}();

_defineProperty(QuestionTypeSwitchStrategyManager, "instance", void 0);

export var questionTypeSwitchManager = QuestionTypeSwitchStrategyManager.getInstance();